import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=dc5a425e&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=dc5a425e&lang=scss&scoped=true&"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=dc5a425e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5a425e",
  null
  
)

export default component.exports